import 'jquery.js';
import { setupLayout } from 'common.js';
import 'jquery-components/bootstrap-dropdown';
import { render } from 'react-dom';
import TourSearchRoot from './components/TourSearchRoot';

export function setupTourSearch(initialState) {
    const root = TourSearchRoot(initialState);
    render(root, document.getElementById('tour-search-results'));
}

export function setupTourDescription(initialState) {
    const root = TourSearchRoot(initialState);
    render(root, document.getElementById('tour-description'));
}

export { setupLayout }